var _rect, _path, _path2, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgConsumerStaples = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#EDEFF2",
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#576F8D",
    d: "M8.976 12.28 8.965 8.64a.637.637 0 0 0-.641-.636c-.299.002-.632.005-.959.006a.33.33 0 0 1-.325-.329.32.32 0 0 1 .324-.32h1.472c.496 0 .898.402.898.898v.574H24.23l.21.102c.269.13.453.4.482.709.02.207-.126.678-1.311 4.235-.733 2.202-1.212 3.721-1.447 4.2l-.005.01c-.194.338-.404.706-.857.706l-4.469.023-7.084-.023c-.47 0-.762-.235-.762-.761z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#576F8D",
    d: "m10.24 20.65 1.6-3.53 1.6.16-2.332 3.78zM11.84 21.439h8v.96h-8z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.88,
    cy: 22.145,
    r: 1.92,
    fill: "#576F8D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.84,
    cy: 21.882,
    r: 1.92,
    fill: "#576F8D"
  })));
};
export default SvgConsumerStaples;